export const statusIcons = {
  done: '✓',
  error: '✕',
  dependencyError: '↳',
  pending: '↳',
  forever: '⯈',
  inProgress: '⠋',
};
